import { Box, Typography } from "@material-ui/core";

export const NoSelectedTask = ({ label }: { label: string }) => {
  return (
    <Box display="flex" flexGrow={1} justifyContent="center" pt={8}>
      <Typography variant="h3">{label}</Typography>
    </Box>
  );
};
